import { render } from "./trashCanB.vue?vue&type=template&id=ae43bb8e"
import script from "./trashCanB.vue?vue&type=script&lang=js"
export * from "./trashCanB.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__